import { ILeftVsRight, ILeftVsRightKeys } from 'twain-sport-fe-mono/interfaces';

const pairArray: ILeftVsRightKeys[] = ['left', 'right'];

export const loopPair = <T>(pairData: ILeftVsRight<T>): T[] =>
    pairArray.map((key) => pairData[key]);

export const getCourtFromLoopIndex = (index: number): ILeftVsRightKeys => pairArray[index];
